import { useState } from "react";
import { TPracticeTypes } from "../../../types/practiceTypes";
import AddTestPractice from "../practice/AddTestPractice";
import AddCodePractice from "../practice/AddCodePractice";
import { usePickedTreeFromUrl } from "./usePickedTreeFromUrl";
import AddPythonPractice from "../practice/AddPythonPractice";

export default function AddPracticeController() {
  const [type, setType] = useState<TPracticeTypes | null>(null);
  const [pickedTree] = usePickedTreeFromUrl();

  return (
    <div className="pt-6 px-4">
      <div className="bg-black/60 rounded-2xl border border-white/10 flex gap-2 items-center p-4 max-w-3xl mx-auto w-full">
        <div className="text-lg/none text-black w-7.5 py-1.5 font-bold text-center bg-yellow-600 rounded-full">
          0
        </div>
        <div className="font-medium text-lg mr-auto">Ne tür pratik eklemek istiyorsun?</div>
        <select
          name="language"
          className="bg-white/20 p-2 pr-4 rounded-lg"
          onChange={(v) => setType(v.target.value as TPracticeTypes)}
        >
          <option>Seç...</option>
          <option value={"TEST" as TPracticeTypes}>Test Sorusu</option>
          <option value={"CODE" as TPracticeTypes}>Sadece kod</option>
          <option value={"PYTHON" as TPracticeTypes}>Python ve preview</option>
          <option value={"REACT" as TPracticeTypes}>Sandpack alıştırması (soon)</option>
        </select>
      </div>
      {type === "TEST" && <AddTestPractice partId={pickedTree.partId!} />}
      {type === "CODE" && <AddCodePractice partId={pickedTree.partId!} />}
      {type === "PYTHON" && <AddPythonPractice partId={pickedTree.partId!} />}
    </div>

  )
}
